import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateExcludePerSupplier = (frameworkAgreementId, lotId, values) => {
  return axios.put(
    `/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/exclude_per_supplier`,
    values
  );
};

export const useUpdateExcludePerSupplier = (frameworkAgreementId, lotId) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateExcludePerSupplier(frameworkAgreementId, lotId, values),
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
